import React, { useState } from 'react';
import './modal.css'; // or inline styles

const Modal = ({ onClose }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    companyName: '',
    email: '',
    phone: '',
    location: '',
    description: '',
    challenges: [],
  });

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    console.log(formData);
    alert('Form submitted!');
    onClose(); // close the modal
  };

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-label="Request a quote form">
      <div className="modalc">
        <h3 className="modal-title">Request a Quote</h3>
        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-row">
            <div className="form-group half">
              <label>First Name *</label>
              <input
                type="text"
                name="firstName"
                required
                value={formData.firstName}
                onChange={handleChange}
              />
            </div>
            <div className="form-group half">
              <label>Last Name *</label>
              <input
                type="text"
                name="lastName"
                required
                value={formData.lastName}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group half">
              <label>Company Name *</label>
              <input
                type="text"
                name="companyName"
                required
                value={formData.companyName}
                onChange={handleChange}
              />
            </div>

            <div className="form-group half">
              <label>Email *</label>
              <input
                type="email"
                name="email"
                required
                value={formData.email}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group half">
              <label>Phone Number *</label>
              <input
                type="tel"
                name="phone"
                required
                value={formData.phone}
                onChange={handleChange}
              />
            </div>

            <div className="form-group half">
              <label>Country/City *</label>
              <input
                type="text"
                name="location"
                required
                value={formData.location}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group half">
              <label>Your Business Description *</label>
              <select
                name="description"
                required
                value={formData.description}
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option value="Retailer">Retailer</option>
                <option value="Distributor">Distributor</option>
                <option value="Wholesaler">Wholesaler</option>
                <option value="Individual">Individual</option>
              </select>
            </div>

            <div className="form-group half">
              <label>What is your biggest accounting challenge? *</label>
              <select
                name="challenges"
                multiple
                required
                value={formData.challenges}
                onChange={e => {
                  const selected = Array.from(e.target.selectedOptions).map(opt => opt.value);
                  setFormData(prev => ({ ...prev, challenges: selected }));
                }}
              >
                <option value="I am not excellent in Accounting/Bookkeeping">
                  I am not excellent in Accounting/Bookkeeping
                </option>
                <option value="I need assistance in Tax preparation/Planning/Declaration">
                  I need assistance in Tax preparation/Planning/Declaration
                </option>
                <option value="I need an advise on accounting Software">
                  I need an advise on accounting Software
                </option>
                <option value="Other">Other</option>
              </select>
              <small className="helper-text">
                Hold Ctrl (Windows) or ⌘ Command (Mac) to select multiple.
              </small>
            </div>
          </div>
          <div className="form-actions">
            <button type="submit" className="btn-primary1">
              Submit
            </button>
            <button type="button" onClick={onClose} className="btn-secondary1">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Modal;
